
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/step/choose-monitored-device",
      function () {
        return require("private-next-pages/android/step/choose-monitored-device.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/step/choose-monitored-device"])
      });
    }
  